"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ThemeProvider = _interopRequireDefault(require("../theme/ThemeProvider"));

var PropulsionApp = function PropulsionApp(props) {
  var children = props.children,
      id = props.id;
  (0, _react.useEffect)(function () {
    if (id) {
      var jssStyles = document.querySelector("#jss-server-side-".concat(id));

      if (jssStyles) {
        jssStyles.parentElement.removeChild(jssStyles);
      }
    }
  }, [id]);
  return /*#__PURE__*/_react.default.createElement(_ThemeProvider.default, null, children);
};

PropulsionApp.propTypes = {
  /**
   * A unique identifier, required if the component was initially rendered by the server.
   *
   * It should match the one used in the server side.
   */
  id: _propTypes.string,

  /** The root component that is using Propulsion. */
  children: _propTypes.node
};
var _default = PropulsionApp;
exports.default = _default;
